import {useContext, useEffect, useState} from "react"
import { AuthContext } from "../AuthContext"
import { PropTypes } from "prop-types";

export const AuthRestrict = ({userRole, children}) => {
    const auth = useContext(AuthContext);

    const [authenticated, setAuthenticated] = useState(false);
    const [authorized, setAuthorized] = useState(false);

    useEffect(() => {
        if(auth && auth.data){
            setAuthenticated(true);

            // Check for role
            if((["admin", "any"].indexOf(userRole) >= 0 && auth.data.adminRole) ||
                (["user", "any"].indexOf(userRole) >= 0 && auth.data.userRole) || !userRole){
                setAuthorized(true);
            }
        }else {
            setAuthenticated(false);
            setAuthorized(false);
        }
    }, [auth, userRole]);


    return  authenticated && authorized ? children : null;
};

AuthRestrict.propTypes = {
    /**
     * User role to restrict on
     */
    userRole: PropTypes.string
}
